import { View } from "@/modules/Roles/models/View";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ViewButton"
})
export default class ViewButton extends Vue {
  @Prop() view!: View;
  @Prop() isActive!: boolean;
  @Prop() isBig!: boolean;
  @Prop() isDisabled!: boolean;
  @Prop() classes!: string;

  onClick() {
    if (this.isDisabled) {
      return;
    }
    this.$emit("click");
  }
}
